<template>
  <div class="container page">
    <AppToolbar :title="retrieved ? retrieved.name : ''" :prev-route="prevRoute">
      <template slot="buttons">
        <v-btn icon @click="deleteShow">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </AppToolbar>

    <div v-if="error || deleteError" class="fill-height">
      <PageNotFound v-if="error === 'Not Found'" />
      <GenericError v-else />
    </div>
    <div v-else class="has-fab">
      <div v-if="isLoading || deleteLoading || !retrieved" class="content-spinner">
        <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
      </div>
      <template v-else>
        <OrganizationForm
          v-if="item"
          ref="form"
          :handle-submit="onSendForm"
          :handle-update-field="updateField"
          :handle-delete="del"
          :values="item"
          :errors="violations"
          :initial-values="retrieved"
        />
      </template>
      <v-btn color="warning" fab fixed bottom right @click="save()">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import GenericError from '@/components/error/GenericError'
import PageNotFound from '@/components/error/PageNotFound'
import { mapActions, mapGetters } from 'vuex'
import OrganizationForm from './Form.vue'
import AppToolbar from '@/components/AppToolbar'

export default {
  components: {
    OrganizationForm,
    GenericError,
    PageNotFound,
    AppToolbar
  },

  data() {
    return {
      item: {},
      prevRoute: {
        name: 'OrganizationShow',
        params: { id: this.$route.params.id }
      }
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'organization/update/isLoading',
      error: 'organization/update/error',
      deleteError: 'organization/del/error',
      deleteLoading: 'organization/del/isLoading',
      created: 'organization/create/created',
      deleted: 'organization/del/deleted',
      retrieved: 'organization/update/retrieved',
      updated: 'organization/update/updated',
      violations: 'organization/update/violations'
    })
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name) {
        vm.prevRoute = { name: from.name, params: from.params }
      }
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function(deleted) {
      if (!deleted) {
        return
      }

      this.$router.push(this.prevRoute)
    },
    updated: function(updated) {
      if (!updated) {
        return
      }

      this.$router.push(this.prevRoute)
    }
  },

  created() {
    this.retrieve('/organizations/' + this.$route.params.id)
  },

  methods: {
    ...mapActions({
      deleteItem: 'organization/del/del',
      retrieve: 'organization/update/retrieve',
      update: 'organization/update/update',
      updateRetrieved: 'organization/update/updateRetrieved'
    }),

    save() {
      this.$refs.form.onSubmit(this.item)
    },

    deleteShow() {
      this.$refs.form.deleteConfirmShow = true
    },

    del() {
      this.deleteItem(this.retrieved)
    },

    onSendForm() {
      this.update()
    },

    updateField(field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
